export default {
    namespaced: true,
    modules: {
        ranking: require("./ranking").default,
    },
    state: {
    },
};


// WEBPACK FOOTER //
// src/store/views/link/index.js